import React from 'react';
import { Box, Skeleton } from '@mui/material';
import { setImagevariant } from '../utils/helpers';

const Img = (props) => {

	const { image, src, variant, skeleton, skeletonProps, width, ...others } = props;
	const imageSrc = variant ? Boolean(image) ? setImagevariant(image.url, Boolean(width) ? width : image.width) : Boolean(src) ? setImagevariant(src, width) : false : src;
	const [loaded, setLoaded] = React.useState(false);

	return(
		<>
			<Box component="img" src={imageSrc} onLoad={() => setLoaded(true)} {...others} />
			{
				(!loaded && skeleton) &&
				<Skeleton {...skeletonProps} />
			}
		</>
	)
}

export default Img;